// extracted by mini-css-extract-plugin
export default {"shareSheet":"styles_shareSheet__fdrLp","item":"styles_item__eF+pg","kakaoIcon":"styles_kakaoIcon__j1eSB","linkIcon":"styles_linkIcon__N6ZQY","txt":"styles_txt__GDx1J"};